if (import.meta.env.MODE === 'development') {
  const utagLogger = (methodName: string) => (data: any) => {
    console.groupCollapsed(`utag.${methodName}`); // eslint-disable-line no-console
    console.log(data); // eslint-disable-line no-console
    console.groupEnd(); // eslint-disable-line no-console
  };

  globalThis.utag = {
    link: utagLogger('link'),
    view: utagLogger('view'),
  };
}

export function sendEvent(category: string, action: string, label: string, eventName: EventDataEventName) {
  const linkData = {
    ga_eventCategory: category,
    ga_eventAction: action,
    ga_eventLabel: label,
    event_name: eventName,
  } as const;

  if (!globalThis.utag) {
    return;
  }

  try {
    globalThis.utag.link(linkData);
  } catch (e: any) {
    console.log('Error sending event to Tealium', e);
  }
}

export function getEnvironment() {
  if (!globalThis.location.host) {
    return;
  }

  const regex = /^.*(?=(\.healthcare)|(\.cuidadodesalud))/g;
  const envArray: Array<string> | null | undefined = globalThis.location.host.match(regex);
  if (!envArray) {
    return;
  }

  return envArray[0] === 'www' ? 'production' : envArray[0];
}

declare global {
  interface Window {
    utag?: {
      view: (data: PageViewData) => void;
      link: (data: EventData) => void;
    };
    utag_data?: PageViewData;
    newrelic?: {
      addRelease: (release_name: string, release_id: string) => void;
      noticeError: (err: Error, customAttributes?: Record<string, any>) => void;
    };
  }
}

type EventDataEventName = 'clear_form' | 'print_page' | 'file_download' | 'calculate_income_unauthenticated';
interface EventData {
  event_name?: EventDataEventName;
  event_type?: 'account login' | 'content tools' | 'conversion' | 'ui interaction';
  user_state?: string;
  state?: string;
  error_code?: string | null;
  error_message?: string | null;
  error_type?: 'validation' | 'system';
  method?: 'direct enrollment' | 'general user' | 'mfa' | null;
  role?: 'consumer' | 'ccr' | 'agent broker';
  security_questions_error_count?: string;
  form_field_label?: string;
  text?: string | null;
  button_style?: 'outline' | 'solid' | 'ghost';
  button_type?: 'submit' | 'link' | 'reset' | 'button';
  link_url?: string | null;
  link_text?: string;
  link_type?: 'link_external' | 'link_internal' | 'link_other';
  html_id?: string | null;
  parent_component_heading?: string;
  parent_component_type?: 'app page' | 'card' | 'footer' | 'page';
  heading?: string;
  type?: 'informative' | 'error' | 'warn' | 'success' | 'lightweight';
  extension?: 'Design system integration';
  event_category?: 'account creation' | 'account login';
  event_action?: string;
  event_noninteraction?: boolean;
  topics_subcategory?: string;
  alert_message?: string; // Ask Blast if error_message or text can be used instead of alert_message
  interaction_text?: string;
  header?: string;
  event_label?: string | null;
}

interface PageViewData {
  content_language: string;
  content_type: 'estimate income page';
  logged_in?: string | null;
  page_name: string;
  site_division: 'apply';
  site_domain: string;
  site_section: 'application - unauthenticated tool';
  site_environment: string | undefined;
  user_state?: string | null;
  base_url?: string;
  role?: EventData['role'];
  page_type?: 'tool';
  page_topic?: 'income';
  page_lifecycle?: 'education';
  page_audience?: 'individual';
  page_category?: 'income-and-household-information';
}
